'use client'
import GoogleMap from "../Components/GoogleMaps";
import { Helmet } from "react-helmet"

export default function Contact() {
  return (
    <>
    <Helmet>
        <title>Contact | Hoeveslagerij De Spycker</title>
        <meta name="description" content="Contacteer ons via e-mail of telefoon. Vind ons op de kaart en raadpleeg onze openingsuren."/>
        <link rel="canonical" href="https://www.hoeveslagerijdespycker.be/contact" />
    </Helmet>
    <div className="mt-20 isolate bg-gray-100 px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
      {/* Google Map */}
      <div className="flex justify-center items-center mb-20" style={{ height: "400px" }}>
        <GoogleMap />
      </div>

      <div className="mb-10 flex flex-col lg:flex-row justify-center items-center w-full max-w-4xl mx-auto space-y-8 lg:space-y-0 lg:space-x-12">
        {/* Openingstijden */}
        <div className="lg:w-1/2 text-lg text-gray-800">
          <h2 className="text-3xl font-semibold text-gray-900 mb-6">Openingsuren</h2>
          <p className="mb-4"><strong>Vrijdag:</strong> Doorlopend van 8u00 tot 18u00</p>
          <p className="mb-4"><strong>Zaterdag:</strong> Doorlopend van 8u00 tot 18u00</p>
          <p className="font-semibold mt-4">
            Telefoonnummer: <a href="tel:+32477292333" className="text-red-900 hover:text-red-500">0477 29 23 33</a>
          </p>
          <p className="mt-4"><strong>Adres:</strong> Spijkerswegel 3, Sint-Kruis</p>
        </div>

        {/* Verlofmelding */}
      {/* <div className="w-11/12 sm:max-w-md md:max-w-lg lg:w-1/2 p-4 sm:p-6 bg-gray-200 border border-red-900 rounded-lg shadow-lg z-10 mt-10 text-center">
        <h4 className="text-xl font-semibold text-red-900">Hemelvaartweekend</h4>
        <p className="mt-2 text-gray-700">
          Vrijdag 15 mei en zaterdag 16 mei GESLOTEN.
        </p>
       </div> */}

        
      </div>

      {/* Contactformulier */}
      {/* <div className="mx-auto max-w-screen-lg text-center">
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Contact info
        </h2>
        <p className="mt-2 text-base text-gray-600 sm:text-xl">
          Stuur ons een bericht
        </p>
      </div> */}

      {/* <form action="#" method="POST" className="mx-auto mt-8 max-w-screen-md sm:mt-8">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2"> */}
          {/* Voornaam */}
          {/* <div>
            <label htmlFor="first-name" className="block text-sm font-semibold text-gray-900">
              Voornaam
            </label>
            <input
              id="first-name"
              name="first-name"
              type="text"
              required
              autoComplete="given-name"
              className="mt-1 block w-full rounded-lg border border-gray-100 bg-white px-4 py-2 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-500 sm:text-base"
            />
          </div> */}

          {/* Achternaam */}
          {/* <div>
            <label htmlFor="last-name" className="block text-sm font-semibold text-gray-900">
              Achternaam
            </label>
            <input
              id="last-name"
              name="last-name"
              type="text"
              required
              autoComplete="family-name"
              className="mt-1 block w-full rounded-lg border border-gray-100 bg-white px-4 py-2 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-500 sm:text-base"
            />
          </div> */}

          {/* E-mail */}
          {/* <div className="sm:col-span-2">
            <label htmlFor="email" className="block text-sm font-semibold text-gray-900">
              E-mail
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              autoComplete="email"
              className="mt-1 block w-full rounded-lg border border-gray-100 bg-white px-4 py-2 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-500 sm:text-base"
            />
          </div> */}

          {/* Telefoonnummer */}
          {/* <div className="sm:col-span-2">
            <label htmlFor="phone" className="block text-sm font-semibold text-gray-900">
              Telefoonnummer
            </label>
            <input
              id="phone"
              name="phone"
              type="tel"
              required
              autoComplete="tel"
              className="mt-1 block w-full rounded-lg border border-gray-100 bg-white px-4 py-2 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-500 sm:text-base"
            />
          </div> */}

          {/* Bericht */}
          {/* <div className="sm:col-span-2">
            <label htmlFor="message" className="block text-sm font-semibold text-gray-900">
              Bericht
            </label>
            <textarea
              id="message"
              name="message"
              rows={4}
              className="mt-1 block w-full rounded-lg border border-gray-100 bg-white px-4 py-2 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-500 sm:text-base"
              defaultValue={''}
            />
          </div>
        </div> */}

        {/* Verzendknop */}
        {/* <div className="mt-8">
          <button
            type="submit"
            className="block w-full rounded-lg bg-red-900 px-6 py-3 text-center text-white font-semibold shadow-md transition hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 sm:text-base"
          >
            Verzenden
          </button>
        </div>
      </form> */}
    </div>
    </>
  )
}
